import { Form, notification } from 'antd';
import classNames from 'classnames/bind';
import md5 from 'md5';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import authAPI from '~/api/AuthAPI';
import CreatePasswordModal from '~/components/form-create-password';
import OTPModal from '~/components/form-otp';
import RegisterModal from '~/components/form-register';
import config from '~/config';
import { auth } from '~/service/firebase';
import { loginPhoneNumber } from '~/store/actions/UserAction';
import firebase from '../../service/firebase';
import styles from './Register.module.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
const cx = classNames.bind(styles);

const Register = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [step, setStep] = useState(1);

    const [dataRegister, setDataRegister] = useState({});
    const [firebaseToken, setFirebaseToken] = useState('');

    // Step 1: Register Form
    const [gender, setGender] = useState();
    const [errPhone, setErrPhone] = useState('');
    const [formRegister] = Form.useForm();

    // formRegister.setFieldsValue(defaultValuesRegister);
    const onFinishRegister = async (data) => {
        try {
            const dataCheck = {
                phone: data.phone,
                type: 'REGISTER',
            };
            const res = await authAPI.checkPhoneAPI(dataCheck);
            if (res?.code === 200 && res?.results?.object?.status) {
                const dataReg = {
                    fullname: data.fullname,
                    phone: data.phone,
                    email: data.email,
                    gender: gender,
                };
                setDataRegister(dataReg);

                sendOTPToPhone(data.phone);
                setStep(2);
            }
        } catch (err) {
            console.log(err);
            if (err.message) {
                setErrPhone(err.message);
            }
        }
    };

    // Step 2: OTP Form
    const [formOTP] = Form.useForm();
    const [otp, setOtp] = useState('');
    const [errOtp, setErrOtp] = useState('');
    const [countErr, setCountErr] = useState(0);
    const defaultValuesOTP = {
        otp: null,
    };
    formOTP.setFieldsValue(defaultValuesOTP);

    const onFinishOTP = () => {
        try {
            if (otp.toString().length !== 6) {
                setErrOtp('Please enter OTP code');
            } else {
                if (otp?.length === 6) {
                    window.confirmationResult
                        .confirm(otp)
                        .then((confirmationResult) => {
                            //eslint-disable-next-line
                            const { accessToken } = confirmationResult.user._delegate;
                            setFirebaseToken(accessToken);
                            setStep(3);
                        })
                        .catch((err) => {
                            const errorFirebase = err.toString().split('/')[1].slice(0, -2);

                            if (errorFirebase === 'invalid-verification-code') {
                                setErrOtp('Invalid OTP code');
                            }
                            const count = countErr + 1;
                            setCountErr(count);
                            if (count === 3) {
                                sendOTPToPhone(dataRegister.phone);
                                setCountErr(0);
                                setErrOtp('OTP code has just been sent back');
                            }
                        });
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    const onChangeOtp = (val) => {
        setOtp(val);
        if (!val) {
            setErrOtp('Please enter OTP code');
        } else {
            setErrOtp('');
        }
    };

    // Step 3: Create password
    const [password, setPassword] = useState('');
    const [errPass, setErrPass] = useState('');

    const onChangePassword = (val) => {
        setPassword(val);
        if (!val) {
            setErrPass('Please enter password');
        } else {
            setErrPass('');
        }
    };

    const onFinishCreatePassword = async () => {
        if (password.length >= 6) {
            try {
                const dataSend = {
                    ...dataRegister,
                    password: md5(password),
                };

                const resNewPass = await authAPI.registerAPI(dataSend);
                if (resNewPass.code === 200) {
                    notification.open({
                        message: 'Account registration successful',
                        duration: 2,
                        placement: 'top',
                    });

                    const dataLoginOTP = {
                        firebaseToken: firebaseToken,
                    };

                    dispatch(
                        loginPhoneNumber(
                            dataLoginOTP,
                            (isSuccess) => {
                                if (isSuccess) {
                                    navigate(config.routes.home);
                                }
                            },
                            (err) => {
                                if (err.message) {
                                    notification.open({
                                        message: err.message,
                                        duration: 2,
                                        placement: 'top',
                                    });
                                }
                                navigate(config.routes.login);
                            },
                        ),
                    );
                }
            } catch (err) {
                console.log(err);
                if (err.message) {
                    notification.open({
                        message: err.message,
                        duration: 2,
                        placement: 'top',
                    });
                }
            }
        } else {
            setErrPass('Please enter password');
        }
    };

    const sendOTPToPhone = async (phone) => {
        if (phone.startsWith('0')) phone = `+84${phone.substring(1)}`;

        try {
            const appVerifier = window.recaptchaVerifier;

            auth.signInWithPhoneNumber(phone, appVerifier)
                .then((confirmationResult) => {
                    window.confirmationResult = confirmationResult;
                })
                .catch((err) => {
                    const errorFirebaseCheck = err.toString().split('/');
                    if (
                        errorFirebaseCheck[0] === 'Error: reCAPTCHA has already been rendered in this element' ||
                        errorFirebaseCheck[1] === 'too-many-requests).'
                    ) {
                        setErrOtp('Sending OTP exceeded the allowed limit, please try again later');
                    }
                });
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
            size: 'invisible',
            callback: function (response) {},
            defaultCountry: 'VN',
        });
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangDangKy');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <div className={cx('container')}>
                <div className={cx('form_container')}>
                    {step === 1 && (
                        <RegisterModal
                            formRegister={formRegister}
                            onFinishRegister={onFinishRegister}
                            gender={gender}
                            setGender={setGender}
                            errPhone={errPhone}
                        />
                    )}
                    {step === 2 && (
                        <OTPModal
                            formOTP={formOTP}
                            otp={otp}
                            errOtp={errOtp}
                            numPhone={dataRegister.phone}
                            onChangeOtp={onChangeOtp}
                            onFinishOTP={onFinishOTP}
                            sendOTPToPhone={sendOTPToPhone}
                        />
                    )}
                    {step === 3 && (
                        <CreatePasswordModal
                            errPass={errPass}
                            numPhone={dataRegister.phone}
                            password={password}
                            onFinishCreatePassword={onFinishCreatePassword}
                            onChangePassword={onChangePassword}
                        />
                    )}
                </div>
            </div>
            <div id="recaptcha-container" visibility="hidden" data-size="invisible"></div>
        </div>
    );
};

export default Register;
